import { render, staticRenderFns } from "./CondicoesParticipacao.vue?vue&type=template&id=8b927c3a"
import script from "./CondicoesParticipacao.vue?vue&type=script&lang=js"
export * from "./CondicoesParticipacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports